import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

const BACKGROUND_SOURCES = ['kite', 'cart-gift-order', 'cart-gift-countdown'];

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = (event) => {
    if (BACKGROUND_SOURCES.includes(event.detail?.data?.source)) return;
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

// customElements.whenDefined('cart-drawer-component').then(() => {
//   const proto = customElements.get('cart-drawer-component')?.prototype;
//   if (!proto) return;

//   proto.open = function () {
//     if (typeof window.openCart === 'function') {
//       window.openCart();
//     } else {
//       console.warn('[Cart] window.openCart() is not available yet.');
//     }
//   };
// });
